import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=8f16fbac&"
import script from "./DoctorCard.vue?vue&type=script&lang=ts&"
export * from "./DoctorCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports